const CANCEL_URL_CALLED_CUSTOM_ACTION =
  'S0007: El usuario va a ser redirigido a la URL de cancelación: ';

export { CANCEL_URL_CALLED_CUSTOM_ACTION };
